<template>
  <div class="blog-page blog-page-posts-index">
    <SfBreadcrumbs class="breadcrumbs desktop-only container-xl" :breadcrumbs="breadcrumbs">
      <template #link="{breadcrumb}">
        <router-link :to="breadcrumb.route.link" class="sf-breadcrumbs__breadcrumb">
          {{ breadcrumb.text }}
        </router-link>
      </template>
    </SfBreadcrumbs>

    <div class="blog-page--hero">
      <div class="container-xl">
        <div class="card-post card-post-hero">
          <div class="card-post__image">
            <SfImage src="/assets/custom/images/ratgeber-intro.jpeg" />
          </div>
          <div class="card-post__text">
            <div class="logo">
              <SfImage src="/assets/custom/logos/logo-ruckzuck-ratgeber-white.png" />
            </div>
            <h1 class="heading">
              Ratgeber
            </h1>
            <p class="description">
              Das RuckZuck DIY Magazin zur Bodenverlegung. Mit vielen Tipps & Tricks, damit Ihr nächstes Projekt ein Erfolg wird.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="posts && posts.length > 0">
      <div class="container-xl">
        <!--<div class="container-xl">
          <post-tile :post="featuredPost" />
        </div>-->

        <div class="blog-page--entries">
          <h2>Tipps & Tricks</h2>
          <div class="row">
            <div
              v-for="(post) in postList"
              :key="post.id"
              class="col-12 col-sm-6 col-md-4 col-lg-3"
            >
              <post-tile :post="post" :class="'card-post-vertical'" />
            </div>
          </div>
        </div>

        <!-- div class="blog-page--pager-container">
          <ul class="blog-page--pager">
            <li class="first"><a href="#"></a></li>
            <li><a href="#">1</a></li>
            <li><a href="#">2</a></li>
            <li><a href="#">3</a></li>
            <li class="dots"><a href="#">...</a></li>
            <li><a href="#">12</a></li>
            <li class="last"><a href="#"></a></li>
          </ul>
        </div -->
      </div>
    </div>

    <div v-else>
      <div class="container-xl">
        <h3>There are no posts.</h3>
      </div>
    </div>

    <hr class="divider container-xl">

    <MSectionUsp />

    <MSectionNewsletter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import i18n from '@vue-storefront/i18n';
import PostTile from './PostTile'
import { getPostImage } from '../../helpers/index'
import MSectionUsp from 'theme/components/molecules/m-section-usp';
import MSectionNewsletter from 'theme/components/molecules/m-section-newsletter';

import {
  SfBreadcrumbs,
  SfImage
} from '@storefront-ui/vue';

export default {
  name: 'PostsIndex',
  components: {
    PostTile,
    MSectionUsp,
    MSectionNewsletter,
    SfBreadcrumbs,
    SfImage
  },
  serverPrefetch () {
    return this.fetchPosts()
  },

  // Client-side only
  mounted () {
    // If we didn't already do it on the server
    // we fetch the item (will first show the loading text)
    if (!this.posts.length) {
      this.fetchPosts()
    }
  },
  computed: {
    ...mapGetters({
      posts: 'wordpress/posts'
    }),

    postList () {
      return this.posts // .slice(1)
    },

    featuredPost () {
      return this.posts.slice(0, 1)[0]
    },

    breadcrumbs () {
      return [
        { text: i18n.t('ruckzuck.store'), route: { link: this.localizedRoute('/') } },
        { text: i18n.t('Ratgeber') }
      ];
    },
    currentRoute () {
      return {
        ...this.navigation.find(navigation => this.localizedRoute(navigation.link) === this.$route.path)
      };
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.length > 0 ? text.substring(0, length) + suffix : ''
    },

    prettyDate: function (date) {
      let newDate = new Date(date)
      let dateFormat = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return newDate.toLocaleDateString('en-GB', dateFormat)
    }
  },
  methods: {
    fetchPosts () {
      return this.$store.dispatch('wordpress/loadPosts', { first: 25 })
    },
    getPostImage (post) {
      let image = getPostImage(post)
      return (image) ? {
        'backgroundImage': `url(${image})`
      } : {
        'backgroundColor': `#ccc`
      }
    },
    getCategory (post) {
      if (typeof post.categories !== 'undefined' && typeof post.categories.edges[0] !== 'undefined') {
        return post.categories.edges[0].node.name;
      }
    }
  }
}
</script>
